const EmailApp = () => import('@/views/mailsystem/index.vue')

export default [
  {
    path: '/mailsystem',
    name: 'mailsystem',
    component: EmailApp,
    meta: {
      action: 'read',
      subject: 'Auth',
    },
  },
  {
    path: '/mailsystem/filter/:filter',
    name: 'mailsystem-filter',
    component: EmailApp,
    meta: {
      action: 'read',
      subject: 'Auth',
    },
  },
  {
    path: '/mailsystem/label/:label',
    name: 'mailsystem-label',
    component: EmailApp,
    meta: {
      action: 'read',
      subject: 'Auth',
    },
  },
]
